<era-pane>
  <h5 class="small-caps"
      i18n>Passcode Lock Grace Period</h5>
  <form [formGroup]="passCodeLockGracePeriodForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label class="form-label"
             for="passCodeLockGracePeriod">Set the Passcode Lock Grace Period</label>
      <input id="passCodeLockGracePeriod"
             formControlName="passCodeLockGracePeriod"
             required="true"
             class="form-control"
             placeholder="a number between 0 and 14400" />
      <small class="form-text text-muted">The number of seconds the screen must be locked before unlock attempts will
        require the device passcode. The
        minimum value is 0 and the maximum value is 14400 seconds.</small>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!passCodeLockGracePeriodForm.valid">Submit</button>
  </form>
</era-pane>